module.exports = require("sanitize-html");